var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_c('v-list-item',{staticClass:"px-6"},[_c('v-list-item-content',[_c('PublishSwitch')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }